<div class="case-header p-3 mt-3 mb-2">
  <!--Loading div-->
  <div *ngIf="!model.name" class="page-wrap d-flex flex-row align-items-center mt-5">
    <div class="container">
      <div class="row justify-content-center">
        <span class="k-icon k-i-loading kendo-loading-icon"></span>
      </div>
    </div>
  </div>
  <div class="row w-100" *ngIf="model.name">
    <div class="col-5">
      <div class="row">
        <div class="col-12 col-xl-12">
          <strong class="montserrat">{{model.channel}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-12">
          {{'CASE-MANAGER' | translate}}:&nbsp;<strong>{{ model.manager }}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-12">
          {{'CASE-ID-NUMBER' | translate}}:&nbsp;<strong>{{ id }}</strong><span style="display: inline-flex"
            class="ml-2">
            <div #tipA kendoTooltip [tooltipTemplate]="caseTimestampTemplate" position="right" aria-live="polite"
              class="keyboard-accessible" tabindex="0" showOn="none" (focus)="showTooltip(timestampTooltip,tipA)"
              (mouseover)="showTooltip(timestampTooltip,tipA)" (blur)="hideTooltip(tipA)"
              (mouseout)="hideTooltip(tipA)">
              <i #timestampTooltip title="" class="fa fa-info-circle pointer" style="color:#fff"></i>
            </div>
          </span>
        </div>
      </div>
      <div class="row" *ngIf="model && model.parentCaseId">
        <div class="col-12 col-xl-12">
          {{'PARENT-CASE-ID-NUMBER' | translate}}:&nbsp;
          <a [routerLink]="['/case', model.parentCaseId]" style="color:#fff">
            <strong>{{model.parentCaseId}}</strong>
          </a><span style="display: inline-flex" class="ml-2">
            <div #tipB kendoTooltip [tooltipTemplate]="parentCaseTimestampTemplate" position="right" aria-live="polite"
              class="keyboard-accessible" tabindex="0" showOn="none" (focus)="showTooltip(parentTimestamp,tipB)"
              (mouseover)="showTooltip(parentTimestamp,tipB)" (blur)="hideTooltip(tipB)" (mouseout)="hideTooltip(tipB)">
              <i #parentTimestamp title="" class="fa fa-info-circle pointer" style="color:#fff"></i>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div class="col-5 pl-0">
      <div class="row">
        <div class="col-4 text-right pr-0 max-label">{{'CASE-STATUS' | translate}}:</div>
        <div class="col-8 pl-1">
          <strong>{{model.status | uppercase | translate}}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-4 text-right pr-0 max-label">{{'PRIORITY' | translate}}:</div>
        <div class="col-8 pl-1">
          <strong>{{ model.priorityKey | translate}}</strong>
        </div>
      </div>
      <div *ngIf="(model.channelWorkflowStatus !== null || model.channelCategoryWorkflowStatusId)" class="row">
        <div class="col-4 text-right pr-0 max-label">{{'CHANNEL-WORKFLOW-STATUS' | translate}}:</div>
        <div class="col-8 pl-1">
          <strong *ngIf="model.channelWorkflowStatus === null">{{'NONE'|translate}}</strong>
          <strong *ngIf="model.channelWorkflowStatus !== null">{{model.channelWorkflowStatus?.displayName }}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-4 text-right pr-0 max-label">{{'SENSITIVITIES' | translate}}:</div>
        <div class="col-8 pl-1 ellipsis-text">
          <strong *ngIf="model.sensitivities.length === 0">{{'NONE'|translate}}</strong>
          <strong title="{{sensitivitiesText}}" *ngIf="sensitivitiesText">{{sensitivitiesText}}</strong>
        </div>
      </div>
    </div>
    <div class="col-2 p-0">
      <div class="row h-100">
        <div class="col my-auto p-0 text-right">
          <!--Actions-->
          <div ngbDropdown class="d-inline-block text-left" placement="bottom-left" container="body" *ngIf="
          (((model.channelWorkflowStatus !== null || model.channelCategoryWorkflowStatusId) && accessEditWorkflow) || accessEditSensitivities) ||
          (model.status === 'Open') ||
          (clinicalSummaryEnabled && model.member?.mrn)">
            <button class="btn btn-outline-primary k-text-uppercase ml-2 mt-2" id="dropdownMoreChoices"
              ngbDropdownToggle>{{'MORE-ACTIONS' | translate}}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMoreChoices">
              <!--Edit Workflow Status and/or Sensitivities-->
              <div
                *ngIf="((model.channelWorkflowStatus !== null || model.channelCategoryWorkflowStatusId) && accessEditWorkflow) || accessEditSensitivities">
                <button
                  *ngIf="(model.channelWorkflowStatus !== null || model.channelCategoryWorkflowStatusId) && accessEditWorkflow"
                  class="dropdown-item k-text-uppercase" (click)="editWorkflowStatus(model.channelId)" ngbDropdownItem>
                  <i class="fal fa-edit fa-header-nav-icon fa-fw"></i>{{'CHANGE-WORKFLOW-STATUS' |
                  translate }}
                </button>
                <button *ngIf="accessEditSensitivities" class="dropdown-item k-text-uppercase"
                  (click)="editCaseSensitivities(model.sensitivities)" ngbDropdownItem>
                  <i class="fal fa-edit fa-header-nav-icon fa-fw"></i>{{'CHANGE-SENSITIVITIES' |
                  translate }}
                </button>
                <div *ngIf="model.status === 'Open'" class="dropdown-divider"> </div>
              </div>
              <!-- reassign case manager -->
              <button *ngIf="model.status === 'Open'" class="dropdown-item k-text-uppercase"
                (click)="assignCaseManagerDialogOpened = true" ngbDropdownItem>
                <i class="fal fa-undo fa-header-nav-icon fa-fw"
                  [ngClass]="{'disabled-text':isCareCoordinator}"></i>{{'REASSIGN-CASE' | translate }}
              </button>
              <!-- change the case priority -->
              <button *ngIf="model.status === 'Open'" class="dropdown-item k-text-uppercase"
                (click)="changeCasePriorityDialogOpened = true" ngbDropdownItem>
                <i class="fal fa-exclamation-triangle fa-header-nav-icon fa-fw"></i>{{'CHANGE-CASE-PRIORITY' |
                translate }}
              </button>
              <!--Download Business Process (BPMN)-->
              @if (isOperatorRole)
              {
              <div class="dropdown-divider"> </div>
              <button class="dropdown-item k-text-uppercase" (click)="downloadBpmn()" ngbDropdownItem>
                <i class="fal fa-download fa-header-nav-icon fa-fw"></i>{{'DOWNLOAD-BPMN' | translate }}
              </button>
              }
              <!-- close the case -->
              <div *ngIf="model.status === 'Open'" class="dropdown-divider"> </div>
              <button *ngIf="model.status === 'Open'" class="dropdown-item k-text-uppercase"
                (click)="openCloseCaseDialog()" ngbDropdownItem>
                <i class="fal fa-times-circle fa-header-nav-icon fa-fw"></i>{{'CLOSE-CASE' | translate }}
              </button>
              <div *ngIf="((clinicalSummaryEnabled && model.member?.mrn) && model.status === 'Open')"
                class="dropdown-divider">
              </div>
              <!-- external link to the Clinical Viewer in HealthShare -->
              <button *ngIf="clinicalSummaryEnabled && model.member?.mrn" class="dropdown-item k-text-uppercase"
                (click)="openClinicalViewer()" ngbDropdownItem>
                <i class="fal fa-external-link fa-header-nav-icon fa-fw"></i>{{'CLINICAL-SUMMARY' | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="col my-auto p-0" style="max-width:30px;padding-top:8px!important;">
          <app-collapsible *ngIf="model.clinicalEncounter" [storageKey]="'case-events'"
            (collapsibleToggle)="caseEventsCollapsed=$event">
          </app-collapsible>
        </div>
      </div>
    </div>
  </div>
  <!--Event Details-->
  <div *ngIf="model.clinicalEncounter">
    <div *ngIf="!caseEventsCollapsed">
      <ng-template [ngTemplateOutlet]="eventDetailsTemplate"
        [ngTemplateOutletContext]="{model: model, isParentCase: false}">
      </ng-template>
    </div>
  </div>
</div>
<div>
  <!-- Tasks List-->
  <div class="row">
    <div class="col-sm-12">
      <hr>
      <h6><span class="text-uppercase montserrat collapsible-text"
          (click)="caseTasksCollapsible.toggleChange()">{{'TASKS' | translate}}</span>
        <div class="float-right">
          <app-collapsible #caseTasksCollapsible [storageKey]="'case-tasks'"
            (collapsibleToggle)="caseTasksCollapsed=$event">
          </app-collapsible>
          <kendo-dropdownlist *ngIf="!caseTasksCollapsed" class="float-right mr-4 k-dropdown ml-4" style="width:140px"
            [data]="taskFilters" [textField]="'text'" [valueField]="'value'" value="{{selectedTaskFilter}}"
            [valuePrimitive]="true" (valueChange)="taskFilterSelected($event)"
            attr.aria-label="{{'TASKS' | translate}}">
          </kendo-dropdownlist>
          <span class="float-right mt-2" *ngIf="!caseTasksCollapsed">
            <!--Card/List View-->
            <app-list-mode [contextMode]="'card'" [storageKey]="'tasks-card-list'" [titleKey]="'VIEW'"
              [defaultMode]="taskViewType" (collapsibleToggle)="taskViewType=$event">
            </app-list-mode>
            <input *ngIf="caseHistoryEnabled" type="checkbox" id="tasksInTimelineCheckbox" class="ml-4"
              [(ngModel)]="includeTasksInTimeline" (change)="updateTimelineEntries()" kendoCheckBox />
            <label *ngIf="caseHistoryEnabled" class="k-checkbox-label"
              for="tasksInTimelineCheckbox">{{'SHOW-IN-TIMELINE' | translate}}</label>
          </span>
        </div>
      </h6>
      <div *ngIf="!caseTasksCollapsed" style="padding-top: 20px;">
        <app-task-card [channelId]="model.channelId" [data]="model.tasks" *ngIf="taskViewType === 'card'">
        </app-task-card>
        <app-case-detail-summary-task-grid *ngIf="taskViewType === 'list'" [model]="model" [refreshCaseOnUpdate]="true"
          [allowAddTask]="true">
        </app-case-detail-summary-task-grid>
      </div>
    </div>
  </div>
  <!-- Referrals-->
  <div class="row" *ngIf="referralsEnabled">
    <div class="col-sm-12">
      <hr>
      <app-case-list-detail [referralsOnly]="true" *ngIf="memberId && caseId" [caseId]="caseId" [memberId]="memberId"
        (referralsOpenStateChanged)="referralsOpenStateChanged($event)">
      </app-case-list-detail>
    </div>
  </div>
  <div class="row w-100" *ngIf="referralsEnabled && !referralsCollapsed">
    <div class="col-12 p-0 ml-3 mt-2 mb-2">
      <button *ngIf="addReferralsEnabled" kendoButton [primary]="false" type="button" (click)="newReferral()"
        class="float-right mt-2">{{'NEW-REFERRAL' | translate}}<i class="far fa-plus"></i>
      </button>
      <button *ngIf="hasExternalSearchSources && mrnStrategy === 'PIX'" kendoButton [primary]="false" type="button"
        (click)="getReferralHistory()" class="float-right mr-3 mt-2">{{'UPDATE-REFERRAL-HISTORY' | translate}}
      </button>
    </div>
  </div>
  <!--Assessments-->
  <app-member-assessment *ngIf="model && model.member" [memberId]="model.member.id" [caseId]="id"
    (refresh)="delayedRefreshCaseDetails()">
  </app-member-assessment>
  <!-- Other Cases List-->
  <div class="row" *ngIf="otherCasesEnabled">
    <div class="col-sm-12">
      <hr>
      <app-case-list-detail [referralsOnly]="false" *ngIf="memberId && caseId" [caseId]="caseId" [memberId]="memberId">
      </app-case-list-detail>
    </div>
  </div>
  <!--Messages List-->
  <div class="row" *ngIf="messagesEnabled">
    <div class="col-sm-12">
      <hr>
      <div class="float-right k-form-field">
        <app-collapsible #caseMessagesCollapsible [storageKey]="'case-messages'" [defaultCollapsed]="true"
          (collapsibleToggle)="caseMessagesCollapsed=$event">
        </app-collapsible>
      </div>
      <h6><span class="text-uppercase montserrat collapsible-text" (click)="caseMessagesCollapsible.toggleChange()">{{
          'MESSAGES' | translate }}</span>
        <div class="float-right mr-4" *ngIf="caseHistoryEnabled">
          <span class="float-right mt-2" *ngIf="!caseMessagesCollapsed">
            <input type="checkbox" id="messagesInTimelineCheckbox" [(ngModel)]="includeMessagesInTimeline"
              (change)="updateTimelineEntries()" kendoCheckBox />
            <label class="k-checkbox-label" for="messagesInTimelineCheckbox">{{'SHOW-IN-TIMELINE' | translate}}</label>
          </span>
        </div>
      </h6>
      <div *ngIf="!caseMessagesCollapsed" style="padding-top: 20px;">
        <div>
          <kendo-grid [data]="messageView.gridData" [loading]="messageView.loading" [navigable]="true"
            [pageable]="messageCount > messageView.state.take ? { buttonCount: 5, pageSizes: pageSizes } : false"
            [pageSize]="messageView.state.take" [skip]="messageView.state.skip" [sortable]="true"
            [sort]="messageView.state.sort" [filterable]="messageEnableAdvanced" [filter]="messageView.state.filter"
            [groupable]="messageEnableAdvanced" [group]="messageView.groups" [selectable]="{ mode: 'single' }"
            [columnMenu]="messageEnableAdvanced" [resizable]="true" [reorderable]="messageEnableAdvanced"
            (dataStateChange)="messageDataStateChange($event)" [kendoGridSelectBy]="">
            <kendo-grid-messages noRecords="{{ 'NO-MESSAGES' | translate }}">
            </kendo-grid-messages>
            <kendo-grid-column field="from" title="{{'FROM' | translate}}"></kendo-grid-column>
            <kendo-grid-column field="to" title="{{'TO' | translate}}">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="ellipsis-text" *ngFor="let to of dataItem.to;let i = index;"
                  [innerHTML]="to.name | cleanAddress:i"></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="sentOn" title="{{ 'SENT-ON' | translate }}" filter="date" format="{0:d}">
            </kendo-grid-column>
            <kendo-grid-column field="subject" title="{{ 'SUBJECT' | translate }}" class="emphasizedLabel">
              <ng-template kendoGridCellTemplate let-dataItem>
                <a class="pointer" (click)="openMessageDetails(dataItem)">
                  <strong>{{ dataItem.subject }}</strong>
                </a>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
          <button id="expandBtn" kendoButton [primary]="true" (click)="composeMessage()" type="button"
            class="mt-3 float-right mb-2 mr-1">
            {{'COMPOSE' | translate}}<i class="far fa-envelope"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Documents -->
  <div class="row" *ngIf="attachmentsEnabled">
    <div class="col-sm-12">
      <div>
        <hr>
        <h6 class="text-uppercase collapsible-text" (click)="caseDocumentsCollapsible.toggleChange()">{{ 'DOCUMENTS' |
          translate }}
          <app-collapsible #caseDocumentsCollapsible [storageKey]="'case-documents'" [defaultCollapsed]="true"
            (collapsibleToggle)="caseDocumentsCollapsed=$event">
          </app-collapsible>
        </h6>
        <div *ngIf="!caseDocumentsCollapsed" style="padding-top: 20px;">
          <app-document [memberId]="member.id" [member]="member" [caseId]="id" [taskId]="" [taskDefinitionId]=""
            [bpmId]="" [messageId]="" [allowSendCaptureLink]="true" [loadTasksAttachments]="true"
            (deletedDocument)="getCaseDetailsData()" (uploadedDocument)="getCaseDetailsData()">
          </app-document>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- case manager assignment dialog -->
<kendo-dialog *ngIf="assignCaseManagerDialogOpened" title="{{'ASSIGN-CASE-TITLE' | translate}}"
  (close)="assignCaseManagerDialogOpened = false;" [minWidth]="350">
  <app-case-assign [aCase]="model" #caseAssign></app-case-assign>
  <kendo-dialog-actions>
    <button kendoButton (click)="assignCaseManagerDialogOpened = false;">{{'CANCEL' | translate}}</button>
    <button appPreventClick kendoButton (click)="caseAssign.save(); assignCaseManagerDialogOpened = false;"
      [disabled]="caseAssign.caseManagerForm.invalid" id="btnSaveChangeCaseManagerCaseDetail">
      {{'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- close case dialog -->
<kendo-dialog *ngIf="closeCaseDialogOpened" (close)="cancelCloseCase()" [minWidth]="400">
  <kendo-dialog-titlebar>
    <h3>{{'CLOSE-CASE' | translate}}</h3>
  </kendo-dialog-titlebar>
  <div class="pt-2 pl-3 pr-3 pb-3">
    <label for="reasonForCloseCase" class="k-text-uppercase dark k-form-field">{{'REASON-FOR-CLOSE-CASE' | translate}} *
      <textarea id="reasonForCloseCase" required class="w-100 k-textarea" kendoTextArea rows="3"
        [(ngModel)]="reasonForClose" style="max-height: 400px;" maxlength="512">
        </textarea>
    </label>
    <div *ngIf="workflowStatuses.length > 0">
      <label for="reasonForCloseCase" class="k-text-uppercase dark k-form-field">{{'NEW-CHANNEL-WORKFLOW-STATUS' |
        translate}}
        <kendo-combobox [filterable]="false" class="w-100" [data]="workflowStatuses" [textField]="'displayName'"
          [valueField]="'id'" [(ngModel)]="channelWorkflowStatusId" [valuePrimitive]="true">
        </kendo-combobox>
      </label>
    </div>
  </div>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="cancelCloseCase()">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick kendoButton type="button" (click)="closeCase()"
      [disabled]="reasonForClose === null || reasonForClose.trim().length === 0">
      {{'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- change priority dialog -->
<kendo-dialog *ngIf="changeCasePriorityDialogOpened" (close)="changeCasePriorityDialogOpened = false;" [minWidth]="450">
  <kendo-dialog-titlebar>
    <h3>{{ 'CHANGE-CASE-PRIORITY-TITLE' | translate}}</h3>
  </kendo-dialog-titlebar>
  <app-case-change-priority [aCase]="model" #caseChangePriority></app-case-change-priority>
  <kendo-dialog-actions>
    <button kendoButton (click)="changeCasePriorityDialogOpened = false;">{{'CANCEL' | translate}}</button>
    <button appPreventClick kendoButton (click)="caseChangePriority.save(); changeCasePriorityDialogOpened = false;"
      [disabled]="caseChangePriority.caseChangePriorityForm === undefined || caseChangePriority.caseChangePriorityForm.invalid">
      {{'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- message dialog-->
<kendo-dialog *ngIf="messageDialogOpened" (close)="messageDialogOpened=false" [minWidth]="400" [width]="700">
  <kendo-dialog-titlebar>
    <h3>{{ 'NEW-MESSAGE' | translate}}</h3>
  </kendo-dialog-titlebar>
  <app-message-compose #messageCompose [messageDialogOpened]="messageDialogOpened" [memberId]="model.member.id"
    [caseId]="id" [messageList]="messageView" [fromMessagesScreen]="'case'" [sendTo]="messageSendTo"
    (afterSave)="messageDialogOpened = false; updateTimelineEntries();"
    (saving)="savingMessage=$event;messageDialogOpened=false">
  </app-message-compose>
  <kendo-dialog-actions>
    <button kendoButton (click)="messageDialogOpened = false" [disabled]="savingMessage">{{ 'CANCEL' | translate
      }}</button>
    <button appPreventClick #submitButton kendoButton type="button"
      [disabled]="!messageCompose.formValid() || savingMessage" (click)="messageCompose.save($event);">
      {{'SEND' | translate}}<i class="fal fa-paper-plane"></i>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- open message details dialog -->
<kendo-dialog *ngIf="messageDetailDialogOpened" (close)="messageDetailDialogOpened = false" [width]="1024">
  <kendo-dialog-titlebar>
    <h3>{{'MESSAGE' | translate}}</h3>
  </kendo-dialog-titlebar>
  <div class="content-background" style="padding:0px;">
    <app-message-detail [message]="selectedMessage"></app-message-detail>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="messageDetailDialogOpened = false">{{ 'CLOSE' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!--Event dialog-->
<app-event-edit-appointment [isNew]="true" [memberId]="memberId" [model]="editDataItemAppointment"
  (cancelling)="cancelAppointmentChangesHandler()" (save)="saveAppointmentChangesHandler()">
</app-event-edit-appointment>

<!--Workflow Status Edit-->
<kendo-dialog [width]="500" (close)="closeWorkflowStatusEdit()" *ngIf="workflowStatusEdit">
  <kendo-dialog-titlebar>
    <h3 class="ellipsis-text">{{(isNewWorkflowStatus ? 'ADD-WORKFLOW-STATUS' : 'EDIT-WORKFLOW-STATUS') | translate}}
    </h3>
  </kendo-dialog-titlebar>
  <form [formGroup]="workflowStatusEditForm" class="k-form">
    <label class="k-form-field mt-3">
      <span class="k-text-uppercase dark">
        {{'NEW-CHANNEL-WORKFLOW-STATUS' | translate}} *
      </span>
      <kendo-combobox [filterable]="false" class="w-100" formControlName="workflowStatus" [data]="workflowStatuses"
        [textField]="'displayName'" [valueField]="'id'">
      </kendo-combobox>
      <div class="k-tooltip k-tooltip-validation" role="alert"
        *ngIf="workflowStatusEditForm.controls['workflowStatus'].invalid && workflowStatusEditForm.controls['workflowStatus'].touched">
        {{'REQUIRED-CHANNEL-STATUS-CODE-SET' | translate}}
      </div>
    </label>
  </form>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="closeWorkflowStatusEdit();">{{ 'CANCEL' | translate}}</button>
    <button appPreventClick kendoButton type="button" [disabled]="workflowStatusEditForm.invalid"
      (click)="updateWorkflowStatus()">{{ 'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!--Sensitivities Edit-->
<kendo-dialog [width]="500" (close)="closeSensitivitiesEdit()" *ngIf="sensitivitiesEdit">
  <kendo-dialog-titlebar>
    <h3 class="ellipsis-text">{{'EDIT-SENSITIVITIES' | translate}}</h3>
  </kendo-dialog-titlebar>
  <form [formGroup]="sensitivitiesEditForm" class="k-form">
    <label class="k-form-field mt-3">
      <span class="k-text-uppercase dark">
        {{'NEW-SENSITIVITIES' | translate}}
      </span>
      <kendo-multiselect [data]="consentableDataTypes" formControlName="sensitivities" [textField]="'displayName'"
        [valueField]="'id'" [autoClose]="true">
        <ng-template kendoMultiSelectItemTemplate let-dataItem>
          <div class="m-1">
            <input type="checkbox" [checked]="isSensitivitiesSelected('sensitivities', dataItem.id)" kendoCheckBox />
            <label class="k-checkbox-label">{{ dataItem.displayName }}</label>
          </div>
        </ng-template>
      </kendo-multiselect>
    </label>
  </form>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="closeSensitivitiesEdit();">{{ 'CANCEL' | translate}}</button>
    <button appPreventClick kendoButton type="button"
      [disabled]="sensitivitiesEditForm.invalid || !sensitivitiesEditForm.dirty" (click)="updateSensitivities()">{{
      'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!--add task dialog-->
<app-task-add *ngIf="model !== undefined && model.channelId !== null && model.channelId !== undefined"
  [dialogOpened]="isNewTask" [channelId]="model.channelId" [caseId]="id" [assigneeId]="createTaskAssigneeId"
  [allowAssigneeOverride]="true" (cancelling)="isNewTask=false;" (save)="afterTaskAdded()">
</app-task-add>

<app-referral [context]="'case'" *ngIf="member !== undefined && member !== null" [memberId]="member.id" [caseId]="id"
  (afterReferralProcessing)="afterReferralProcessing($event)" #referral>
</app-referral>

<!--open task dialog, adjusting width to get toolbar in notes on one line -->
<div class="k-overlay" *ngIf="taskOpened"></div>
<kendo-window id="task-detail" [width]="1300" [height]="590" *ngIf="taskOpened" (close)="closeTaskDialog()"
  style="position:fixed" [top]="60" [state]="windowState">
  <kendo-window-titlebar>
    <div class="k-window-title">
      <h3 class="ellipsis-text">{{selectedTask.name}}</h3>
    </div>
    <button kendoWindowMaximizeAction></button>
    <button kendoWindowRestoreAction></button>
    <button kendoWindowCloseAction></button>
  </kendo-window-titlebar>
  <app-task-detail [task]="selectedTask" [autoComplete]="autoComplete" (completed)="onTaskCompleted()"
    (closeTaskDetail)="closeTaskDetail()" (followUpTaskAddedEvent)="getCaseDetailsData()" [isDialog]="true">
  </app-task-detail>
  <kendo-dialog-actions style="position:absolute;margin-left:-16px" class="w-100 mt-3">
    <button kendoButton [primary]="true" type="button" (click)="closeTaskDialog()">
      {{ 'CLOSE' | translate}}</button>
  </kendo-dialog-actions>
</kendo-window>

<!--Case tooltip template-->
<ng-template #caseTimestampTemplate>
  <ng-template [ngTemplateOutlet]="timestampTemplate" [ngTemplateOutletContext]="{model: model}">
  </ng-template>
</ng-template>

<!--Parent Case tooltip template-->
<ng-template #parentCaseTimestampTemplate>
  <ng-template [ngTemplateOutlet]="timestampTemplate" [ngTemplateOutletContext]="{model: model.parentCaseDetail}">
  </ng-template>
  <div *ngIf="model.parentCaseDetail.clinicalEncounter">
    <ng-template [ngTemplateOutlet]="eventDetailsTemplate"
      [ngTemplateOutletContext]="{model: model.parentCaseDetail, isParentCase: true}">
    </ng-template>
  </div>
</ng-template>

<!--Case and Parent Case timestamp template-->
<ng-template #timestampTemplate let-model="model">
  <span>
    {{'ADDED-BY-TIMESTAMP' | translate}}&nbsp;<strong>{{model.createdBy}}</strong>&nbsp;{{'TIMESTAMP-ON' |
    translate}}&nbsp;<strong>{{intl.formatDate(intl.parseDate(model.createdOn),'g')}}</strong>
  </span>
  <br />
  <span>
    {{'UPDATED-BY-TIMESTAMP' | translate}}&nbsp;<strong>{{model.lastModifiedBy}}</strong>&nbsp;{{'TIMESTAMP-ON' |
    translate}}&nbsp;<strong>{{intl.formatDate(intl.parseDate(model.lastModifiedOn),'g')}}</strong>
  </span>
  <span *ngIf="model.enrollmentReason || model.channel || model.manager"><br /></span>
  <span *ngIf="model.channel">
    <br />
    {{'CHANNEL' | translate}}:&nbsp;<strong>{{model.channel}}</strong>
  </span>
  <span *ngIf="model.manager">
    <br />
    {{'CASE-MANAGER' | translate}}:&nbsp;<strong>{{model.manager}}</strong>
  </span>
  <span *ngIf="model.enrollmentReason">
    <br />
    {{'ENROLLMENT-REASON' | translate}}:&nbsp;<strong>{{model.enrollmentReason}}</strong>
  </span>
</ng-template>

<!--Event Details template - Used for the Event Details panel and Parent Case Id tooltip-->
<ng-template #eventDetailsTemplate let-model="model" let-isParentCase="isParentCase">
  <h6 class="text-uppercase event-details-header" [ngClass]="{'event-details-width': isParentCase}">{{'EVENT-DETAILS' |
    translate}}
  </h6>
  <div class="row pl-3 pr-3">
    <div class="col-8 pl-0" style="padding-top: 20px;">
      <div *ngIf="!model.clinicalEncounter?.referral">
        {{'FACILITY' | translate}}:
        <i *ngIf="model.clinicalEncounter.facility" class="fas fa-hospital"></i>&nbsp;
        {{model.clinicalEncounter.facility}}
        <div *ngIf="!model.clinicalEncounter?.referral && model.clinicalEncounter?.encounter?.treatingProvider">
          {{'TREATING-PROVIDER' | translate}}:&nbsp;
          <i *ngIf="model.clinicalEncounter?.encounter?.treatingProvider" class="fas fa-user-md"></i>&nbsp;
          {{model.clinicalEncounter.encounter.treatingProvider}} &nbsp;
        </div>
      </div>
      <div *ngIf="model.clinicalEncounter.encounter">
        <div
          *ngIf="model.clinicalEncounter.encounter.providerPhoneNumber || model.clinicalEncounter.encounter.providerEmail">
          <i *ngIf="model.clinicalEncounter.encounter.providerPhoneNumber" class="fas fa-phone"></i>
          {{model.clinicalEncounter.encounter.providerPhoneNumber | phone }} &nbsp;
          <i *ngIf="model.clinicalEncounter.encounter.providerEmail" class="fas fa-envelope"></i>&nbsp;
          {{model.clinicalEncounter.encounter.providerEmail}}
        </div>
      </div>
      <div *ngIf="model.clinicalEncounter.details" class="row">
        <div class="col-4 col-xl-3">
          {{(model.referredToCommunityProgram !== null || model.clinicalEncounter?.referral?.referredServiceName !==
          null ? 'REFERRED-SERVICE' : 'REASON-FOR-VISIT') |
          translate}}:
        </div>
        <div class="col-8 col-xl-9">
          {{model.clinicalEncounter.details}}
        </div>
      </div>
      <div
        *ngIf="model.clinicalEncounter?.referral?.reason && (model.referredToCommunityProgram === null && model.clinicalEncounter?.referral?.referredServiceName === null)"
        class="row">
        <div class="col-4 col-xl-3">
          {{ 'REFERRED-REASON' | translate}}:
        </div>
        <div class="col-8 col-xl-9">
          {{model.clinicalEncounter.referral.reason}}
        </div>
      </div>
      <div *ngIf="model.referredToCommunityProgram !== null || model.clinicalEncounter?.referral?.serviceType !== null"
        class="row">
        <div class="col-4 col-xl-3">
          {{ 'COMMUNITY-SERVICE-TYPE' | translate}}:
        </div>
        <div class="col-8 col-xl-9">
          {{model.clinicalEncounter?.referral?.serviceType !== null ?
          model.clinicalEncounter?.referral?.serviceType :
          model.referredToCommunityProgram.serviceCategory.serviceType.displayName}}
        </div>
      </div>
      <div
        *ngIf="model.referredToCommunityProgram !== null || model.clinicalEncounter?.referral?.serviceCategory !== null"
        class="row">
        <div class="col-4 col-xl-3">
          {{ 'COMMUNITY-SERVICE-CATEGORY' | translate}}:
        </div>
        <div class="col-8 col-xl-9">
          {{model.clinicalEncounter?.referral?.serviceCategory !== null ?
          model.clinicalEncounter?.referral?.serviceCategory : model.referredToCommunityProgram.serviceCategory.name}}
        </div>
      </div>
      <div *ngIf="model.clinicalEncounter?.referral?.date" class="row">
        <div class="col-4 col-xl-3">
          {{'REFERRED-DATE' | translate}}:
        </div>
        <div class="col-8 col-xl-9">
          {{ intl.formatDate(intl.parseDate(model.clinicalEncounter.referral.date), "d")}}
        </div>
      </div>
      <div *ngIf="model.clinicalEncounter?.referral?.start" class="row">
        <div class="col-4 col-xl-3">
          {{'REFERRED-START' | translate}}:
        </div>
        <div class="col-8 col-xl-9">
          {{ intl.formatDate(intl.parseDate(model.clinicalEncounter.referral.start), "d")}}
        </div>
      </div>
      <div *ngIf="model.clinicalEncounter?.referral?.end" class="row">
        <div class="col-4 col-xl-3">
          {{'REFERRED-END' | translate}}:
        </div>
        <div class="col-8 col-xl-9">
          {{ intl.formatDate(intl.parseDate(model.clinicalEncounter.referral.end), "d")}}
        </div>
      </div>
      <div *ngIf="model.clinicalEncounter.encounter && model.clinicalEncounter.encounter.encounterNumber" class="row">
        <div class="col-4 col-xl-3">
          {{'ENCOUNTER-NUMBER' | translate}}:
        </div>
        <div class="col-8 col-xl-9">
          {{model.clinicalEncounter.encounter.encounterNumber}}
        </div>
      </div>
      <!--Community Program Referral From-->
      <div *ngIf="model.clinicalEncounter && model.clinicalEncounter.referral">
        <div class="row mt-2" *ngIf="((model.referredFromUser && model.referredFromUser.name && model.clinicalEncounter.referral?.referredFromName === null) ||
                                        (model.clinicalEncounter?.referral?.referredFromName !== null))">
          <div class="col-4 col-xl-3">
            {{'REFERRED-FROM' | translate}}:&nbsp;
          </div>
          <div class="col-8 col-xl-9">
            <div
              *ngIf="model.referredFromUser && model.referredFromUser.name && model.clinicalEncounter.referral?.referredFromName === null">
              <i class="fas fa-user pr-1"></i>&nbsp;{{model.referredFromUser.name}} <span
                *ngIf="model.referredFromUser !== null && model.referredFromUser.organization !== null"> -
                {{model.referredFromUser.organization.name}}</span>
            </div>
            <div *ngIf="model.clinicalEncounter?.referral?.referredFromName !== null">
              <i class="fas fa-user"></i>&nbsp;{{model.clinicalEncounter?.referral?.referredFromName}} <span
                *ngIf="model.clinicalEncounter?.referral?.referredFromOrganizationName !== null">
                ({{model.clinicalEncounter?.referral?.referredFromOrganizationName}})</span>
            </div>
          </div>
        </div>
        <div *ngIf="model.referredFromUser?.email || model.clinicalEncounter?.referral?.referralEmail !== null"
          class="row">
          <div class="col-4 col-xl-3"></div>
          <div class="col-8 col-xl-9 contact-smaller">
            <i class="fas fa-envelope contact-padding"></i>&nbsp;{{ model.clinicalEncounter?.referral?.referralEmail
            !== null ? model.clinicalEncounter?.referral?.referralEmail : model.referredFromUser.email}}
          </div>
        </div>
        <div
          *ngIf="model.referredFromUser?.phoneNumber || model.clinicalEncounter?.referral?.referralPhoneNumber !== null"
          class="row">
          <div class="col-4 col-xl-3"></div>
          <div class="col-8 col-xl-9 contact-smaller">
            <span>
              <i class="fas fa-phone contact-padding"></i>&nbsp;{{
              (model.clinicalEncounter?.referral?.referralPhoneNumber !== null ?
              model.clinicalEncounter?.referral?.referralPhoneNumber : model.referredFromUser.phoneNumber) | phone}}
            </span>
          </div>
        </div>
      </div>
      <div *ngIf="model.referredFrom">
        <div class="row mt-2">
          <div class="col-4 col-xl-3">
            {{'REFERRED-FROM' | translate}}:&nbsp;
          </div>
          <div class="col-8">
            <div *ngIf="model.referredFrom?.name?.fullName">
              <i class="fas fa-user-md"></i>&nbsp; {{model.referredFrom.name.fullName}}
            </div>
          </div>
        </div>
        <div class="row" *ngIf="model.referredFrom?.contact?.homePhoneNumber">
          <div class="col-4 col-xl-3">
          </div>
          <div class="col-8 col-xl-9 contact-smaller">
            <i class="fas fa-phone contact-padding"></i>
            {{model.referredFrom.contact.homePhoneNumber | phone}}
          </div>
        </div>
        <div class="row" *ngIf="model.referredFrom?.contact?.email">
          <div class="col-4 col-xl-3">
          </div>
          <div class="col-8 col-xl-9 contact-smaller">
            <i class="fas fa-envelope contact-padding"></i>&nbsp;
            {{model.referredFrom.contact.email}}
          </div>
        </div>
      </div>
      <!--Community Program Referral To-->
      <div *ngIf="model.referredToCommunityProgram || model.clinicalEncounter?.referral?.referredServiceName !== null">
        <div class="row mt-2">
          <div class="col-4 col-xl-3">
            {{'REFERRED-TO' | translate}}:&nbsp;
          </div>
          <div class="col-8 col-xl-9" *ngIf="model.referredToCommunityProgram">
            <i *ngIf="model.referredToCommunityProgram?.organization?.name" class="fas fa-hospital-user"></i>&nbsp;
            <span
              *ngIf="model.referredToCommunityProgram?.referralContactName">{{model.referredToCommunityProgram?.referralContactName}}
              ({{model.referredToCommunityProgram?.organization?.name}})</span>
            <span *ngIf="!model.referredToCommunityProgram?.referralContactName">
              {{model.referredToCommunityProgram?.organization?.name}}</span>
          </div>
          <div class="col-8 col-xl-9" *ngIf="model.clinicalEncounter?.referral?.referredServiceName">
            <i *ngIf="model.clinicalEncounter?.referral?.referredServiceName" class="fas fa-hospital-user"></i>&nbsp;
            <span
              *ngIf="model.clinicalEncounter?.referral?.referredToOrganizationName">{{model.clinicalEncounter?.referral?.referredServiceName}}
              ({{model.clinicalEncounter?.referral?.referredToOrganizationName}})</span>
            <span *ngIf="!model.clinicalEncounter?.referral?.referredToOrganizationName">
              {{model.clinicalEncounter?.referral?.referredServiceName}}</span>
          </div>
        </div>
        <div
          *ngIf="model?.referredToCommunityProgram?.referralPhoneNumber || model?.referredToCommunityProgram?.referralFaxNumber"
          class="row">
          <div class="col-4 col-xl-3"></div>
          <div class="col-8 col-xl-9 contact-smaller">
            <div class="contact-padding">
              <i class="fas fa-phone"></i>&nbsp;{{model.referredToCommunityProgram.referralPhoneNumber | phone}}
              &nbsp;
              <i class="fas fa-fax"></i>&nbsp;{{model.referredToCommunityProgram.referralFaxNumber | phone}}
            </div>
          </div>
        </div>
        <div *ngIf="model?.referredToCommunityProgram?.referralEmail" class="row">
          <div class="col-4 col-xl-3"></div>
          <div class="col-8 col-xl-9 contact-smaller">
            <i class="fas fa-envelope contact-padding"></i>&nbsp;{{model.referredToCommunityProgram.referralEmail}}
          </div>
        </div>
        <div *ngIf="model?.referredToCommunityProgram?.referralUrl" class="row">
          <div class="col-4 col-xl-3"></div>
          <div class="col-8 col-xl-9 contact-smaller ">
            <a class="contact-padding" *ngIf="model.referredToCommunityProgram.referralUrl" target="_blank"
              href="{{model.referredToCommunityProgram.referralUrl}}" style="color:#fff">{{'WEB-SITE' | translate}}
            </a>
          </div>
        </div>
      </div>
      <div *ngIf="model.referredTo">
        <div class="row mt-2">
          <div class="col-4 col-xl-3">
            {{'REFERRED-TO' | translate}}:&nbsp;
          </div>
          <div class="col-8 col-xl-9">
            <i *ngIf="model.referredTo.name.fullName"
              class="fas fa-user-md"></i>&nbsp;{{model.referredTo.name.fullName}}
          </div>
        </div>
        <div *ngIf="model.referredTo.contact.homePhoneNumber" class="row">
          <div class="col-4 col-xl-3"></div>
          <div class="col-8 col-xl-9 contact-smaller">
            <i class="fas fa-phone contact-padding"></i>&nbsp;{{model.referredTo.contact.homePhoneNumber | phone}}
          </div>
        </div>
        <div *ngIf="model.referredTo.contact.email" class="row">
          <div class="col-4 col-xl-3"></div>
          <div class="col-8 col-xl-9 contact-smaller">
            <i class="fas fa-envelope contact-padding"></i>&nbsp;{{model.referredTo.contact.email}}
          </div>
        </div>
      </div>
    </div>
    <!--Community Program Submitting Organization-->
    <div class="col-4" style="padding-top: 20px;"
      *ngIf="model.referredToCommunityProgram && model.referredToCommunityProgram.submittingOrganization">
      <div class="row">
        <div class="col-12">
          {{'SUBMITTING-ORGANIZATION' | translate}}:&nbsp;
        </div>
        <div class="col-12">
          <span>{{model.referredToCommunityProgram.submittingOrganization.name}}
            ({{model.referredToCommunityProgram.submittingOrganization?.organizationType?.displayName}})</span>
        </div>
      </div>
    </div>
    <div class="col-4" *ngIf="model.clinicalEncounter?.referral?.authorization">
      <div *ngIf="model.clinicalEncounter?.referral?.authorization?.authorizingPayerCompanyName">
        {{'REFERRAL-AUTHORIZING-PAYER-NAME' | translate}}:
        {{model.clinicalEncounter.referral.authorization.authorizingPayerCompanyName}}
      </div>
      <div *ngIf="model.clinicalEncounter?.referral?.authorization?.authorizingPayerPlanId">
        {{'REFERRAL-AUTHORIZING-PLAN' | translate}}:
        {{model.clinicalEncounter.referral.authorization.authorizingPayerPlanId}}
      </div>
      <div *ngIf="model.clinicalEncounter?.referral?.authorization?.authorizationId">
        {{'REFERRAL-AUTHORIZATION-NUMBER' | translate}}:
        {{model.clinicalEncounter.referral.authorization.authorizationId}}
      </div>
      <div *ngIf="model.clinicalEncounter?.referral?.authorization?.requestedNumberOfTreatments">
        {{'REFERRAL-REQUESTED-NUMBER-OF-TREATMENTS' | translate}}:
        {{model.clinicalEncounter.referral.authorization.requestedNumberOfTreatments}}
      </div>
      <div *ngIf="model.clinicalEncounter?.referral?.authorization?.authorizedNumberOfTreatments">
        {{'REFERRAL-AUTHORIZED-NUMBER-OF-TREATMENTS' | translate}}:
        {{model.clinicalEncounter.referral.authorization.authorizedNumberOfTreatments}}
      </div>
      <div *ngIf="model.clinicalEncounter?.referral?.authorization?.reimbursementLimit">
        {{'REFERRAL-REIMBURSEMENT-LIMIT' | translate}}:
        {{model.clinicalEncounter.referral.authorization.reimbursementLimit}}
      </div>
    </div>
  </div>
</ng-template>